import script from "./FeedbackFormSent.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackFormSent.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackFormSent.vue?vue&type=style&index=0&id=4dbaf62b&lang=scss"

const __exports__ = script;

export default __exports__